import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IDailyProctorScheduleModel, IExam } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-auto-dps',
  templateUrl: './auto-dps.component.html',
  styleUrls: ['./auto-dps.component.scss']
})
export class AutoDpsComponent implements OnInit {
  exam: IExam = examDefault;

  modelError = '';

  DpsAuto: IDailyProctorScheduleModel = {
    examinationID: 0,
    utcDailyStartTime: undefined,
    utcDailyEndTime: undefined,
    excludeWeekends: false,
    maxCandidateNoPerDay: 0
  }
  constructor(private popoverRef: PopoverRef<AutoDpsComponent>,
    private examService: ExamService, private snackBar: SnackbarService,) { }

  ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
    }
  }

  close() {
    this.popoverRef.close();
  }

  async generateDPS() {

    this.DpsAuto.examinationID = this.exam.id;
    await this.examService.generateDPS(this.DpsAuto).then((s: any) => {
      this.snackBar.success('Daily Proctor Schedule generated successfully');
      this.close();
    }).catch((e) => {
      console.log(e);
      // this.snackBar.open(e, 'CLOSE', {
      //   duration: 3000,
      //   horizontalPosition: 'right', verticalPosition: 'top'
      // });
    });
  }


  validateModel() {
    if (this.DpsAuto.maxCandidateNoPerDay == 0) {
      this.modelError += "\n*Max Candidate Number. PerDay required\n"
    } if (this.DpsAuto.utcDailyEndTime == undefined) {
      this.modelError += "\n*Daily EndTime required\n"
    } if (this.DpsAuto.utcDailyStartTime == undefined) {
      this.modelError += "\n*Daily StartTime Format required\n"
    }
  }
}
